import gql from 'graphql-tag'

export const UPDATE_FILELIST = gql`
  mutation UpdateFileList($input: UpdateFileListInput!) {
    updateFileList(input: $input) {
      isSuccessful
      updateFileList {
        message
      }
    }
  }
`

export const SET_UPLOAD_MEDIA = gql`
  mutation SetUploadMedia($input: SetUploadMediaInput!) {
    setUploadMedia(input: $input) {
      isSuccessful
      message
      setUploadMedia {
        message
        data {
          downloadId
          endTime
          downloadOn
          startTime
          identifier
          channel
          mediaFilename
          status
          url
          vehicleId
        }
      }
    }
  }
`

export const SET_DEVICE_STREAM = gql`
  mutation SetDeviceStream($input: SetDeviceStreamInput!) {
    setDeviceStream(input: $input) {
      isSuccessful
      message
      status
      setDeviceStream {
        message
      }
    }
  }
`
